import CharacterAPI from '@/api/character'

/**
 * 캐릭터 리스트 조회
 * @param {*} obj
 */
const getCharacterList = ({ state, commit, dispatch }, params) => {
  CharacterAPI.getCharacterList(params, responseData => {
    const {
      list,
      totalCount,
      totalPageCount,
      pageNo,
      pageSize
    } = responseData.data

    commit('SET_CHARACTER_LIST', {
      characterList: list,
      totalCount: totalCount,
      totalPageCount: totalPageCount,
      pageNo: pageNo,
      pageSize: pageSize
    })
  })

  // let mockData
  // if (params.pageNo === 1) {
  //   mockData = {
  //     code: 0,
  //     message: 'success',
  //     data: {
  //       list: [
  //         {
  //           gid: '1276', // Game Service ID
  //           worldId: 'UNION', // 월드 ID
  //           worldName: '유니온', // 월드명칭
  //           gcid: 'UNION:3259418860505923982', // 캐릭터 ID
  //           gcName: '뚜따다야', // 캐릭터 이름
  //           gcLevel: 145, // 캐릭터 레벨
  //           gcClass: '히어로'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3489711583827919992',
  //           gcName: '아데루삥뽕',
  //           gcLevel: 144,
  //           gcClass: '보우마스터'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '팬텀'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '스트라이커'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '메르세데스'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '아크'
  //         },
  //         {
  //           gid: '1276', // Game Service ID
  //           worldId: 'UNION', // 월드 ID
  //           worldName: '유니온', // 월드명칭
  //           gcid: 'UNION:3259418860505923982', // 캐릭터 ID
  //           gcName: '뚜따다야', // 캐릭터 이름
  //           gcLevel: 145, // 캐릭터 레벨,
  //           gcClass: '히어로'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3489711583827919992',
  //           gcName: '아데루삥뽕',
  //           gcLevel: 144,
  //           gcClass: '보우마스터'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '팬텀'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '스트라이커'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '메르세데스'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '아크'
  //         },
  //         {
  //           gid: '1276', // Game Service ID
  //           worldId: 'UNION', // 월드 ID
  //           worldName: '유니온', // 월드명칭
  //           gcid: 'UNION:3259418860505923982', // 캐릭터 ID
  //           gcName: '뚜따다야', // 캐릭터 이름
  //           gcLevel: 145, // 캐릭터 레벨,
  //           gcClass: '히어로'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3489711583827919992',
  //           gcName: '아데루삥뽕',
  //           gcLevel: 144,
  //           gcClass: '보우마스터'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '팬텀'
  //         }
  //       ],
  //       totalCount: 18,
  //       totalPageCount: 2,
  //       pageNo: 1,
  //       pageSize: 15
  //     }
  //   }
  // } else {
  //   mockData = {
  //     code: 0,
  //     message: 'success',
  //     data: {
  //       list: [
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '보우마스터'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '팬텀'
  //         },
  //         {
  //           gid: '1276',
  //           worldId: 'UNION',
  //           worldName: '유니온',
  //           gcid: 'UNION:3062547102844847343',
  //           gcName: '추르르추릅',
  //           gcLevel: 7,
  //           gcClass: '히어로'
  //         }
  //       ],
  //       totalCount: 18,
  //       totalPageCount: 2,
  //       pageNo: 2,
  //       pageSize: 15
  //     }
  //   }
  // }

  // const { list, totalCount, totalPageCount, pageNo, pageSize } = mockData.data

  // commit('SET_CHARACTER_LIST', {
  //   characterList: list,
  //   totalCount,
  //   totalPageCount,
  //   pageNo,
  //   pageSize
  // })
}

const getSelectedCharacter = ({ state, commit, dispatch }) => {
  CharacterAPI.getSelectedCharacter(responseData => {
    const selectedCharacter = responseData.data
    commit('SET_SELECTED_CHARACTER', {
      selectedCharacter: selectedCharacter || {}
    })
  })

  // const mockCharacter = {
  //   code: 0,
  //   message: 'success',
  //   data: {
  //     gid: '1276',
  //     worldId: 'UNION',
  //     worldName: '유니온',
  //     gcid: 'UNION:3062547102844847343',
  //     gcName: '추르르추릅',
  //     gcLevel: 7,
  //     gcClass: '히어로'
  //   }
  // }

  // commit('SET_SELECTED_CHARACTER', {
  //   selectedCharacter: mockCharacter.data
  // })
}

const setCharacter = ({ state, commit, dispatch }, params) => {
  CharacterAPI.setCharacter(params, responseData => {
    commit('SET_SELECTED_CHARACTER', {
      selectedCharacter: params
    })
  })
}

const updateCharacter = ({ state, commit, dispatch }, params) => {
  CharacterAPI.updateCharacter(params, responseData => {
    commit('SET_SELECTED_CHARACTER', {
      selectedCharacter: params
    })
  })
}

const updateSortType = ({ state, commit, dispatch }, sortType) => {
  // 0 이름순
  // 1 레벨순
  commit('SET_SORT_TYPE', {
    sortType
  })
}

export default {
  getCharacterList,
  getSelectedCharacter,
  setCharacter,
  updateCharacter,
  updateSortType
}
